import { render, staticRenderFns } from "./GraphTitle&FAQ.vue?vue&type=template&id=450c8908"
import script from "./GraphTitle&FAQ.vue?vue&type=script&lang=js"
export * from "./GraphTitle&FAQ.vue?vue&type=script&lang=js"
import style0 from "./GraphTitle&FAQ.vue?vue&type=style&index=0&id=450c8908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports